import { useState } from 'react';
import { useParams } from 'react-router';
import { ChatPanel } from '../components/ChatPanel';
import { ReferenceTray } from '../components/ReferenceTray';
import { useChat } from '../hooks/useApi';

/**
 * Vista de chat:
 *  - Desktop (≥md): grid 2 columnas — referencias | chat.
 *  - Mobile (<md): tabs entre 💬 chat y 📎 referencias (solo uno visible). El chat
 *    es el default porque es lo que se usa más; las refs aparecen al apretar el
 *    tab. Garantiza que el chat ocupe el 100% del ancho en mobile sin
 *    apretarse contra el panel lateral.
 */
export function ChatPage() {
  const { chatId } = useParams();
  const { data: chat } = useChat(chatId ?? '');
  const [mobileTab, setMobileTab] = useState<'chat' | 'refs'>('chat');

  if (!chatId) return null;

  return (
    <div className="flex flex-col h-full md:grid md:grid-cols-[280px_1fr]">
      {/* Tabs mobile (sm-) */}
      <div className="md:hidden flex shrink-0 border-b border-slate-800 bg-slate-900/50">
        <button
          onClick={() => setMobileTab('chat')}
          className={`flex-1 py-2 text-xs font-medium transition-colors ${
            mobileTab === 'chat'
              ? 'text-vision border-b-2 border-vision'
              : 'text-slate-400 border-b-2 border-transparent'
          }`}
        >
          💬 Chat
        </button>
        <button
          onClick={() => setMobileTab('refs')}
          className={`flex-1 py-2 text-xs font-medium transition-colors ${
            mobileTab === 'refs'
              ? 'text-vision border-b-2 border-vision'
              : 'text-slate-400 border-b-2 border-transparent'
          }`}
        >
          📎 Referencias
        </button>
      </div>

      {/* Reference tray: en desktop siempre visible (aside izq); en mobile solo
          cuando mobileTab=refs. */}
      <aside
        className={`border-r border-slate-800 bg-slate-900/50 overflow-y-auto ${
          mobileTab === 'refs' ? 'flex-1 md:flex-none' : 'hidden md:block'
        }`}
      >
        <ReferenceTray chatId={chatId} instanceId={chat?.instanceId} />
      </aside>

      {/* Chat panel: en desktop siempre visible (col 2); en mobile solo cuando
          mobileTab=chat. */}
      <section
        className={`overflow-hidden ${
          mobileTab === 'chat' ? 'flex-1 md:flex-none' : 'hidden md:block'
        }`}
      >
        <ChatPanel chatId={chatId} />
      </section>
    </div>
  );
}
